/* istanbul ignore file */
import rootReducer from '@/redux/rootReducer';
import thunk from 'redux-thunk';
import { tokenMiddleware } from '@/middleware';
import { createStore, applyMiddleware  } from 'redux';
import logger from 'redux-logger';

const store = createStore(rootReducer, applyMiddleware(logger, thunk, tokenMiddleware));

export const hasGranted = (accessLevel) => {
    const user = store.getState().AuthReducer.user;

    return user.roles.includes(accessLevel);
}

export const notGranted = (accessLevel) => {
    const user = store.getState().AuthReducer.user;

    return !user.roles.includes(accessLevel);
}

export const checkRole = (roles) => {
    const user = store.getState().AuthReducer.user;

    if (!user.hasOwnProperty('roles')) {
        return false;
    }

    let hasRole = 0;
    roles.map(role => {
        if (user.roles.includes(role)) hasRole++;

        return role;
    })

    return hasRole > 0;
}

export const isAdmin = () => {
    const user = store.getState().AuthReducer.user;

    if (!user.hasOwnProperty('roles')) {
        return false;
    }
    
    const isDirecteur = user.roles.includes('ROLE_DIRECTEUR');
    const isAdmin = user.roles.includes('ROLE_ADMIN');
    return  (isDirecteur || isAdmin);
}

export default store;